import { type ReactElement } from 'react';
import { useForm, Edit } from '@refinedev/antd';
import { Form, Input } from 'antd';

import type { AdminCustomer } from '@/types';

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function CustomerEdit(): ReactElement {
  const { formProps, saveButtonProps } = useForm<AdminCustomer>();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Name" name="name">
          <Input />
        </Form.Item>

        <Form.Item label="Phone" name="phone">
          <Input />
        </Form.Item>

        <Form.Item label="Country (ISO code)" name="country">
          <Input maxLength={10} />
        </Form.Item>
      </Form>
    </Edit>
  );
}
